export default "__VITE_ASSET__o$wSE$$r__"